import React from 'react';
import { useLocation } from 'react-router-dom';
import { useBreakpoint } from 'hooks';
import { AuthContext, ExternalAuthContext, LayoutContext } from 'contexts';
import styled from 'styled-components';
import {
  featureEnabled,
  getJSON,
  hasLinkAccountMlsRolloutFeature,
} from 'utils';
import { StyledContainer, StyledSider, SupraLogo } from './StyledComponents';
import LogoSection from './LogoSection';
import MenuSection from './MenuSection';
import Trigger from './Trigger';

const SideMenu: React.FC = props => {
  const {
    siderCollapsed,
    setSiderCollapsed,
    siderBaseWidth,
    getSiderCurrentWidth,
    offsetTop,
    transition,
    siderCollapsedWidth: initialCollapsedWidth,
  } = React.useContext(LayoutContext);

  const { auth } = React.useContext(AuthContext);
  const { auth: extAuth } = React.useContext(ExternalAuthContext);

  const location = useLocation();
  const { md } = useBreakpoint();
  const [collapsedWidth, setCollapsedWidth] = React.useState(
    initialCollapsedWidth,
  );

  React.useEffect(() => {
    if (!md && (auth || extAuth)) setSiderCollapsed(true);
  }, [location, auth, extAuth]);

  React.useEffect(() => {
    if (!md && (auth || extAuth)) {
      setCollapsedWidth(0);
      setSiderCollapsed(true);
    } else {
      setCollapsedWidth(initialCollapsedWidth);
      setSiderCollapsed(false);
    }
  }, [md, auth, extAuth]);

  const showLinkAccountFeature =
    featureEnabled('linkAccountFeature') &&
    hasLinkAccountMlsRolloutFeature(
      [
        ...new Set(
          auth.linkedAccounts.flatMap(({ mlsTypes }) => mlsTypes ?? []),
        ),
      ],
      getJSON('linkAccountMlsRolloutFeature'),
    );

  const offset = showLinkAccountFeature ? offsetTop + 64 : offsetTop;

  return (
    <StyledContainer
      $siderCurrentWidth={getSiderCurrentWidth()}
      $transition={transition}
    >
      <StyledSider
        $offsetTop={offset}
        $isMobile={showLinkAccountFeature ? false : !md}
        collapsible
        collapsed={siderCollapsed}
        onCollapse={setSiderCollapsed}
        collapsedWidth={collapsedWidth}
        width={siderBaseWidth}
        trigger={<Trigger collapsed={siderCollapsed} isMobile={!md} />}
      >
        {!showLinkAccountFeature && (
          <>
            <SupraLogo collapsed={siderCollapsed} />
          </>
        )}
        <Height24 />
        <LogoSection
          collapsed={siderCollapsed}
          imageOveride={
            auth?.org?.locations[+auth.location]?.logo ||
            auth?.org?.logoUrl ||
            ''
          }
        />
        <Height24 />
        <MenuSection />
        {showLinkAccountFeature && (
          <SupraLogo
            collapsed={siderCollapsed}
            style={{ marginTop: 'auto', paddingTop: 50 }}
          />
        )}
      </StyledSider>
    </StyledContainer>
  );
};

const Height24 = styled.div`
  height: 24px;
`;

export default SideMenu;
